var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f4bb3b;}.cls-3{fill:#ff5a5a;}.cls-4{fill:#1682fe;}.cls-5{fill:#60d8a4;}.cls-6{fill:#3a3a3a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.45 11.86 31.5 11.81 31.45 11.86 31.45 11.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.31,4.69A16,16,0,0,0,4.69,27.31l.2.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.8,
    y: 21.66,
    width: 27.71,
    transform: "translate(-8.97 21.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.86,31.45,31.45,11.86a15.8,15.8,0,0,0-4.14-7.17L4.69,27.31l.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.31,27.31a16,16,0,0,0,4.14-15.45L11.86,31.45A16,16,0,0,0,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.69,4.69A16,16,0,0,0,.55,20.14l6.67-6.67L20.14.55A16,16,0,0,0,4.69,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.31,4.69A15.8,15.8,0,0,0,20.14.55L7.22,13.47.55,20.14a16,16,0,0,0,4,7l.14.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.45,11.86,11.86,31.45A16,16,0,0,0,31.45,11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.69,27.31a15.89,15.89,0,0,0,7.17,4.14L24.78,18.53l6.67-6.67a16,16,0,0,0-4-7l-.14-.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.31,4.69A16,16,0,0,0,4.69,27.31a15.8,15.8,0,0,0,7.17,4.14L31.45,11.86A15.8,15.8,0,0,0,27.31,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.31,27.31a16,16,0,0,0,4.14-15.45L11.86,31.45A16,16,0,0,0,27.31,27.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.55 20.14 7.22 13.47 0.55 20.14 0.55 20.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.55,27.18l.14.13.2.2-.2-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "7.22 13.47 20.14 0.55 20.14 0.55 7.22 13.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25.2,13.7V9.1H22.9V6.8H18.3V4.5H13.7V6.8H9.1V9.1H6.8V22.9H9.1v2.3h4.6v2.3h4.6V25.2h4.6V22.9h2.3V18.3H20.6v2.3H18.3v2.3H13.7V20.6H11.4V11.4h2.3V9.1h4.6v2.3h2.3v2.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvxLogo);
export default __webpack_public_path__ + "static/media/cvxLogo.ef244dd836cbef233384487157c5335e.svg";
export { ForwardRef as ReactComponent };